<template>
  <div class="animated fadeIn">
    <b-alert
    dismissible
    :show="showDismissibleAlert"
    variant="danger"
    @dismissed="showDismissibleAlert=false">{{ alertMessage }}</b-alert>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <div class="row">
              <div class="col-sm-5">
                  <h4 class="card-title mb-0">Couriers</h4>
              </div><!--col-->
          </div><!--row-->
           <hr />
          <form novalidate id="query">
            <div class="form-group row">
              <label for="inputDeliveryCountryCode" class="col-sm-2 col-form-label">Destination Country*:</label>
              <div class="col-sm-4">
                <select v-model="country_code" name="country_code" id="inputDeliveryCountryCode" class="form-control" required @change='changeCountry'>
                  <option value="">-- Select One --</option>
                  <option v-for="(country, index) in countries" :value="country.code" :key="index">{{ country.name }}</option>
                </select>
              </div>
              <div class="col-sm-3 help-block with-errors"></div>
            </div>
            <div class="form-group row">
              <label for="inputDeliveryStateCode" class="col-sm-2 col-form-label">Destination State:</label>
              <div class="col-sm-4">
                <select v-model="state_code" name="state_code" id="inputDeliveryStateCode" class="form-control">
                  <option value="">-- Select One --</option>
                  <option v-for="(state, index) in states" :value="state.code" :key="index">{{ state.name }}</option>
                </select>
              </div>
              <div class="col-sm-3 help-block with-errors"></div>
            </div>
            <div class="form-group row">
              <label for="inputWarehouseId" class="col-sm-2 col-form-label">Warehouse*:</label>
              <div class="col-sm-4">
                <select v-model="warehouse_id" name="state_code" id="inputWarehouseId" required class="form-control">
                  <option value="">-- Select One --</option>
                  <option v-for="(warehouse, index) in warehouses" :value="warehouse.id" :key="index">{{ warehouse.name }}</option>
                </select>
              </div>
              <div class="col-sm-3 help-block with-errors"></div>
            </div>
            <div class="form-group row">
              <label for="inputPostcode" class="col-sm-2 col-form-label">Postcode:</label>
              <div class="col-sm-3">
                <input type="text" v-model="postcode" name="postcode" id="inputPostcode" class="form-control" value="">
              </div>
              <div class="col-sm-3 help-block with-errors"></div>
            </div>
            <div class="form-group row">
              <label for="inputWeight" class="col-sm-2 col-form-label">Weight (kg)*:</label>
              <div class="col-sm-3">
                <input type="number" v-model="weight" name="weight" id="inputWeight" class="form-control" value="" min="0.01" max="" step="0.01" required>
              </div>
              <div class="col-sm-3 help-block with-errors"></div>
            </div>
            <div class="form-group row">
              <label for="inputServiceType" class="col-sm-2 col-form-label">Service Type:</label>
              <div class="col-sm-4">
                <select v-model="service_type" name="service_type" id="inputServiceType" class="form-control">
                  <option value="">-- Select One --</option>
                  <option value="EXPED"> EXPED </option>
                  <option value="EXP"> EXP </option>
                  <option value="STD"> STD </option>
                  <option value="ESGD"> ESGD </option>
                </select>
              </div>
              <div class="col-sm-3 help-block with-errors"></div>
            </div>
            <div class="form-group row">
              <label for="inputBatteryType" class="col-sm-2 col-form-label">Battery Type:</label>
              <div class="col-sm-3">
                <select v-model="battery_type" name="battery_type" id="inputBatteryType" class="form-control">
                  <option value="">-- Select One --</option>
                  <option value="PI965"> PI965 </option>
                  <option value="PI966"> PI966 </option>
                  <option value="PI967"> PI967 </option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="inputIncoterm" class="col-sm-2 col-form-label">Incoterm:</label>
              <div class="col-sm-2">
                <select v-model="incoterm" name="incoterm" id="inputIncoterm" class="form-control">
                  <option value="">-- Select One --</option>
                  <option value="DDU"> DDU </option>
                  <option value="DDP"> DDP </option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="inputMaxDimension" class="col-sm-2 col-form-label">Max Dimension</label>
              <div class="col-sm-8">
                <div class="form-row">
                  <div class="col-4 input-group">
                    <input v-model="length" type="number" step="1" name="max_length" class="form-control" id="inputFuelSurchargePercent ">
                    <div class="input-group-addon">cm</div>
                  </div>

                  <div class="col-4 input-group">
                    <input v-model="width" type="number" step="1" name="max_width" class="form-control" id="inputFuelSurchargePercent ">
                    <div class="input-group-addon">cm</div>
                  </div>

                  <div class="col-4 input-group">
                    <input v-model="height" type="number" step="1" name="max_height" class="form-control" id="inputFuelSurchargePercent ">
                    <div class="input-group-addon">cm</div>
                  </div>

                </div>
                <small id="inputMaxDimension" class="form-text text-muted">Lenght x Width x Height</small>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-sm-10 col-sm-offset-2">
                <button type="submit" class="btn btn-primary" @click.stop.prevent="onSubmit">Submit</button>
              </div>
            </div>
          </form>
          <div class="row table-responsive" v-if="deliveryOptions.length">
            <div class="col-md-12">
              <table class="table table-bordered table-hover">
                <thead>
                  <tr>
                    <th>Courier name</th>
                    <th>Currency</th>
                    <th>Courier total cost</th>
                    <th>Courier free cost</th>
                    <th>DDP charge</th>
                    <th>Fuel surcharge</th>
                    <th>Others fee</th>
                    <th>Lead time</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(courierCost, index) in deliveryOptions" :key="index">
                    <td>{{ courierCost.courier }}</td>
                    <td>{{ courierCost.currency }}</td>
                    <td>{{ courierCost.total_cost }}</td>
                    <td>{{ courierCost.free_cost }}</td>
                    <td>{{ courierCost.ddp_surcharge }}</td>
                    <td>{{ courierCost.fuel_surcharge }}</td>
                    <td>{{ courierCost.others.other_fee }}</td>
                    <td>{{ courierCost.lead_time }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FreightComparisonTool',
  mounted () {
    this.axios.get('/country').then(reponse => { this.countries = reponse.data })
    this.axios.get('/warehouse').then(reponse => { this.warehouses = reponse.data })
  },
  data () {
    return {
      showLoadingPanel: false,
      showDismissibleAlert: false,
      alertMessage: '',
      country_code: '',
      state_code: '',
      warehouse_id: '',
      postcode: '',
      weight: '',
      service_type: '',
      battery_type: '',
      incoterm: '',
      length: '',
      width: '',
      height: '',
      countries: [],
      states: [],
      warehouses: [],
      deliveryOptions: []
    }
  },
  methods: {
    onSubmit () {
      this.showDismissibleAlert = true
      this.deliveryOptions = []
      // if (!$('#query')[0].checkValidity()) {
      //   $('#query').addClass('was-validated')
      //   return
      // }
      this.axios.post('/delivery/option', {
        delivery_country_code: this.country_code,
        delivery_state_code: this.state_code,
        postcode: this.postcode,
        warehouse_id: this.warehouse_id,
        weight: this.weight,
        service_type: this.service_type,
        battery_type: this.battery_type,
        incoterm: this.incoterm,
        length: this.length,
        width: this.width,
        height: this.height
      }).then(response => {
        this.deliveryOptions = response
      }).catch(response => {
        if (response.status === 404) {
          this.showAlert(response.data.message)
        }
      })
    },
    changeCountry () {
      if (this.country_code) {
        this.axios.get('/country/' + this.country_code + '/states').then(response => {
          this.states = response.data
        }).catch(response => {
          if (response.status === 404) {
            this.states = []
            this.state_code = ''
          }
        })
      }
    },
    showAlert (message) {
      this.showDismissibleAlert = true
      this.alertMessage = message
    }
  },
  computed: {
  }
}
</script>
